import axios from 'axios';
import { useState,useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { Phone, CheckCircle, ChefHat, CreditCard } from 'lucide-react';
import { toast } from 'react-toastify';
import ReactCountryFlag from 'react-country-flag';
import styles from './SubscriptionPage.module.css'; // Make sure to update your CSS file name if you change it
import { sendOtpApi } from '../http/api';
import { v4 as uuidv4 } from 'uuid';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslate } from '../components/UseTranslate';
import {LanguageSwitcher} from '../components/LanguageSwitcher'

const SUBSCRIPTION_PACKS = [
  { id: 'daily_sub', name: 'UVFOODBOX daily CM', price: '60', duration: 'XAF / day', type: 'Subscription' },
  { id: 'weekly_sub', name: 'UVFOODBOX weekly CM', price: '300', duration: 'XAF / week', type: 'Subscription' },
  { id: 'onetime_daily', name: 'UVFOODBOX daily acte CM', price: '70', duration: 'XAF', type: 'One-Time' },
  { id: 'onetime_weekly', name: 'UVFOODBOX weekly acte CM', price: '350', duration: 'XAF', type: 'One-Time' },
];

export function SubscriptionPage() {
  const [formData, setFormData] = useState({
    msisdn: '',
  });

  const { t } = useTranslate();


  const {language} = useSelector(
    (state) => state.language
  );
  console.log(language,'language------------------')

  const [loading,setLoading] = useState(false);

  const [searchParams] = useSearchParams();
const ext_ref = searchParams.get('ext_ref') || uuidv4();


useEffect(()=>{
  localStorage.clear()
  localStorage.setItem('ext_ref',ext_ref)
  
},[ext_ref])
  
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!formData.msisdn || formData.msisdn.length !== 9) {
      toast.error(t('Please enter a valid 9-digit Cameroon mobile number.'));
      return;
    }

    const fullMsisdn = `237${formData.msisdn}`;
    // navigate('/otp',{state:{msisdn:formData.msisdn}});

    try {
      const { data } = await axios.post(sendOtpApi, { msisdn: fullMsisdn });
      setLoading(false);

      if (data?.status === 1) {
        toast.success(data?.msg)
        navigate('/otp',{state:{msisdn:fullMsisdn}});
        return;
      }

      toast.error(data?.message || 'Unable to send OTP. Please try again.');
    } catch (error) {
      console.error('OTP request failed', error);
      setLoading(false);
      toast.error(t(error?.response?.data?.msg));
    }
  };

  const handleChange = (e) => {
    if (e.target.name === 'msisdn') {
      const digits = e.target.value.replace(/\D/g, '').slice(0, 9);
      setFormData({
        ...formData,
        msisdn: digits,
      });
      return;
    }

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className={styles.container}>
  <div className={styles.leftSection}>

    <div className={styles.header}>
      <div className={styles.logo}>
        <img src="/logo.png" alt="UVFood Box" className={styles.logoImage} />
        <span>UVFood Box</span>
      </div>

    </div>

    <div className={styles.hero}>
      <h1>
        {t('DISCOVER')} <span>{t('INCREDIBLE')} </span>
        {t('RECIPES')}
      </h1>

      <p>
        {t("Share your culinary creations and explore recipes from chefs around the world.")}
      </p>
    </div>

    <div className={styles.stats}>
      <div className={styles.statItem}>
        <div className={styles.statIcon}><ChefHat /></div>
        <div className={styles.statText}>
          <span className={styles.statValue}>500+</span>
          <span className={styles.statLabel}>{t('Recipes')}</span>
        </div>
      </div>

      <div className={styles.statItem}>
        <div className={styles.statIcon}>⏰</div>
        <div className={styles.statText}>
          <span className={styles.statValue}>20 Min</span>
          <span className={styles.statLabel}>{t('Avg. Cook Time')}</span>
        </div>
      </div>

      <div className={styles.statItem}>
        <div className={styles.statIcon}>⭐</div>
        <div className={styles.statText}>
          <span className={styles.statValue}>4.8</span>
          <span className={styles.statLabel}>{t('User Rating')}</span>
        </div>
      </div>
    </div>
    <br/>

    <form onSubmit={handleSubmit} className={styles.subscriptionForm} >
      <label className={styles.inputLabel}>{t('Enter your mobile number (MSISDN)')}</label>

      <div className={styles.msisdnRow}>
        <div className={styles.flagPill} className={styles.inputField}>
          <ReactCountryFlag
            countryCode="CM"
            svg
            style={{
              width: '20px',
              height: '14px',
            }}
            title="Cameroon"
          />
          <span className={styles.countryCode}>+237</span>
          <span style={{marginTop:'-8px'}}>|</span>
        
          {/* <Phone className={styles.phoneIcon} /> */}
          <input
            type="tel"
            name="msisdn"
            value={formData.msisdn}
            onChange={handleChange}
            placeholder={t('Enter 9 digit number')}
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={9}
          />
        </div>
      </div>

      <p className={styles.helperText}>{t('Enter exactly 9 digits (e.g. 650123456)')}</p>

      <button type="submit" className={styles.subscribeBtn} disabled={loading}>
        {loading ? "S'ABONNER...." : t('Continue') }
      </button>
    </form>

    <p className={styles.terms}>
      {t('By subscribing, you agree to our')}
      <span> {t('Terms & Conditions')} </span>
    </p>

    <div className={styles.features}>
      <div>
        📖
        <span>{t('Step-by-Step Instructions')}</span>
      </div>

      <div>
        ❤️
        <span>{t('Save Your Favorites')}</span>
      </div>

      <div>
        🛒
        <span>{t('Smart Grocery List')}</span>
      </div>
    </div>

<br/>
    <p className={styles.footerText}>
      {t('Delicious starts here')} ❤️
    </p>

  </div>

  <div className={styles.rightSection}>
    <img
      src="/images/food-banner.png"
      alt="Food"
      className={styles.foodImage}
    />
  </div>
  <LanguageSwitcher/>
</div>
  );
}